// extracted by mini-css-extract-plugin
export var card = "_l4-5";
export var cardSelected = "_l4-4";
export var image = "_l4-3";
export var modal = "_l4-0";
export var modalContent = "_l4-1";
export var table = "_l4-2";